const style = {
    button: {
        width: "32px",
        height: "32px",
        fontFamily: "IBM Plex Sans",
        marginLeft: "7px",
        marginRight: "7px",
        padding: "0",
        textAlign: "center",
        boxSizing: "border-box",
    },
    unAvailableButton: {
        color: "#4E6D6F",
        opacity: "0.3"
    },
    availableButton: {
        borderRadius: "8px",
        border: "1px solid #06844D",
        color: "#06844D",
    },
    selectedButton: {
        backgroundColor: "#06844D",
        color: "#ffffff",
        borderRadius: "8px"
    },
    textDay: {
        padding: "0",
        margin: "0",
        fontSize: "clamp(10px, 3.46vw, 24px)",
    }
}

export default style;
